import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatasourceDirective } from './datasource.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        DatasourceDirective
    ],
    exports: [
        DatasourceDirective
    ]
})
export class DataSourceModule {
}
